module.exports = __webpack_public_path__ + "static/media/icon-star-solid.c580bc66.svg";